(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    // Strip commas, currency symbols etc — Shopify money_without_currency can output "3,999"
    function parseNum(str) {
      return parseFloat(String(str).replace(/[^\d.]/g, '')) || 0;
    }

    function initPriceRangeSlider(wrapper) {
      const rangeMin  = parseNum(wrapper.dataset.rangeMin);
      const rangeMax  = parseNum(wrapper.dataset.rangeMax);
      const currency  = wrapper.dataset.currencySymbol || '';

      const sliderMin = wrapper.querySelector('.price-range-slider__input--min');
      const sliderMax = wrapper.querySelector('.price-range-slider__input--max');
      const rangeBar  = wrapper.querySelector('.price-range-slider__range');
      const labelMin  = wrapper.querySelector('.price-range-slider__label-min');
      const labelMax  = wrapper.querySelector('.price-range-slider__label-max');

      // Fix slider min/max attrs to use clean parsed numbers (no commas)
      sliderMin.min   = rangeMin;
      sliderMin.max   = rangeMax;
      sliderMax.min   = rangeMin;
      sliderMax.max   = rangeMax;

      // Set initial values cleanly
      const initMin   = parseNum(sliderMin.value) || rangeMin;
      const initMax   = parseNum(sliderMax.value) || rangeMax;
      sliderMin.value = initMin;
      sliderMax.value = initMax;

      const facetComp = wrapper.closest('price-facet-component');
      const inputMin  = facetComp ? facetComp.querySelector('[ref="minInput"]') : null;
      const inputMax  = facetComp ? facetComp.querySelector('[ref="maxInput"]') : null;

      function formatPrice(val) {
        return currency + Math.round(val).toLocaleString('en-IN');
      }

      function updateTrack() {
        const minVal = parseNum(sliderMin.value);
        const maxVal = parseNum(sliderMax.value);
        const minPct = ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        const maxPct = ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        rangeBar.style.left  = minPct + '%';
        rangeBar.style.width = (maxPct - minPct) + '%';
        labelMin.textContent = formatPrice(minVal);
        labelMax.textContent = formatPrice(maxVal);
      }

      /**
       * Use native value setter so web-component internal watchers fire correctly.
       */
      function setNativeValue(el, val) {
        if (!el) return;
        const nativeSetter = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype, 'value'
        ).set;
        nativeSetter.call(el, val);
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // While dragging — update visuals only
      sliderMin.addEventListener('input', () => {
        if (parseNum(sliderMin.value) > parseNum(sliderMax.value)) {
          sliderMin.value = sliderMax.value;
        }
        updateTrack();
      });

      sliderMax.addEventListener('input', () => {
        if (parseNum(sliderMax.value) < parseNum(sliderMin.value)) {
          sliderMax.value = sliderMin.value;
        }
        updateTrack();
      });

      // On drag-end — sync hidden inputs & trigger Shopify filter
      function onDragEnd() {
        const minVal = parseNum(sliderMin.value);
        const maxVal = parseNum(sliderMax.value);
        setNativeValue(inputMin, minVal > rangeMin ? String(minVal) : '');
        setNativeValue(inputMax, maxVal < rangeMax ? String(maxVal) : '');
      }

      sliderMin.addEventListener('change', onDragEnd);
      sliderMax.addEventListener('change', onDragEnd);

      // Initial render — show labels immediately
      updateTrack();
    }

    function init() {
      document.querySelectorAll('.price-range-slider').forEach((wrapper) => {
        if (wrapper.dataset.priceSliderInit) return;
        wrapper.dataset.priceSliderInit = '1';
        initPriceRangeSlider(wrapper);
      });
    }

    // Re-init on Shopify AJAX section loads
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('.price-range-slider').forEach(
        (w) => delete w.dataset.priceSliderInit
      );
      init();
    });

    // MutationObserver — catches Shopify filter AJAX DOM replacements
    // (facets re-render injects new HTML; section:load does NOT fire for filter updates)
    const observer = new MutationObserver(() => {
      document.querySelectorAll('.price-range-slider:not([data-price-slider-init])').forEach((wrapper) => {
        wrapper.dataset.priceSliderInit = '1';
        initPriceRangeSlider(wrapper);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
